1<template>
    <div class="p-6 flex flex-col">
        <pending-request :users="users"></pending-request>
        
        <transfer-requests :users="users"></transfer-requests>
    </div>
</template>

<script>
import PendingRequest from "../../components/TransferOwnership/PendingRequest";
import TransferRequests from "../../components/TransferOwnership/TransferRequests";

export default {
  components: {
    PendingRequest,
    TransferRequests
  },

  data() {
    return {
      users: []
    };
  },

  mounted() {
    this.getVaultUsers();
  },

  methods: {
    getVaultUsers() {
      axios.get(`/api/vaults/${this.$route.params.vault_id}/users`).then(({ data }) => {
        this.users = data.data;
      });
    }
  }
};
</script>

<style>
</style>
